import WarningColored from '@/images/WarningColored.svg';
import {
    Buttons,
    DeleteCloseButton,
    DeleteDialog,
    DeleteText,
    StyledButton,
    Text,
    TitleWithImg,
} from '@/pages/avatar/components/Styled/Modal';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    open: boolean;
    onClose: () => void;
    onCancel: () => void;
    onConfirm: () => void;
    cancelText?: string;
    confirmText?: string;
    message?: string;
}

export const LeaveConfirmationModal = ({ open, onClose, onCancel, onConfirm, cancelText, confirmText, message }: Props) => {
    return (
        <DeleteDialog open={open}>
            <div>
                <TitleWithImg>
                    <img src={WarningColored} />
                    <Text>Unsaved changes</Text>
                </TitleWithImg>
                <DeleteCloseButton ariaLabel="close" onClick={onClose}>
                    <CloseIcon />
                </DeleteCloseButton>
            </div>
            <DeleteText>{message || 'You have unsaved changes, do you want to save them now?'}</DeleteText>
            <Buttons>
                <StyledButton onClick={onCancel} variant="outlined" color="secondary">
                    {cancelText || 'Leave'}
                </StyledButton>
                <StyledButton onClick={onConfirm} variant="contained" color="secondary">
                    {confirmText || 'Save changes'}
                </StyledButton>
            </Buttons>
        </DeleteDialog>
    );
};
